<template>
  <div class="article" :key="`${article.articleId}--${key}`">
    <span class="info">
      <h4>{{ article.name }}</h4>
      <p v-if="article.remainingQuantity">
        Left to print: {{ article.remainingQuantity }}
      </p>
      <p
        v-if="article.remainingQuantity"
        @click="setMaxToAllLabels"
        class="underline cursor-pointer w-1/63 orange"
      >
        Select remaining for print
      </p>
    </span>
    <div v-if="computedLabels.length > 1" class="flex w-56 my-2 mb-4">
      <number-input
        :error="setAllError"
        v-model="setAll"
        label-placeholder="Set print amount for all labels"
      />
    </div>
    <div
      v-for="label in computedLabels"
      :key="`${article.articleId}--${label.labelId}`"
      class="flex justify-between px-4 mb-5 rounded labels bg-primary-light"
    >
      <h4 class="w-1/3">{{ label.name ? label.name : label.labelName }}</h4>
      <div class="flex items-center justify-end w-1/2">
        <number-input
          @input="setLabelQuantityForPrinting(label, $event)"
          v-model="label.quantity"
          :value="label.quantity"
          :id="`${article.articleId}--${label.labelId}`"
          :ref="`${article.articleId}--${label.labelId}`"
          :error="errors[label.labelId]"
          label-placeholder="Print amount"
        />
      </div>
      <h4 @click="fetchPreview(label)" class="underline cursor-pointer w-1/63">
        Preview
      </h4>
    </div>
    <modal v-if="showPreview" type="success" @close="hidePreview">
      <template slot="body">
        <div
          style="max-width: 800px; max-height: 600px"
          class="relative flex justify-center"
        >
          <img
            class="object-contain labelpreview"
            :src="currentPreview"
            alt="label"
          />
        </div>
      </template>
    </modal>
    <loading
      v-if="loading"
      heading="Loading"
      description="Generating preview"
    />
    <modal
      v-if="errorMessage"
      type="error"
      heading="Error"
      :description="errorMessage"
      @close="errorMessage = null"
    >
    </modal>
  </div>
</template>
<script>
import NumberInput from "../components/forms/NumberInput";
import Modal from "./Modal";
import Loading from "./Loading";
export default {
  data: () => ({
    setAll: "",
    key: 0,
    errors: {},
    setAllError: "",
    currentPreview: "",
    showPreview: false,
    loading: false,
    errorMessage: null,
  }),
  components: {
    NumberInput,
    Modal,
    Loading,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    labels: {
      type: Array,
      required: true,
    },
    orderData: {
      type: Array,
      default: () => [],
    },
    orderId: {
      type: Number,
      default: () => null,
    },
    connector: {
      type: String,
      required: false,
    }
  },
  computed: {
    computedLabels() {
      return this.labels;
    },
    remainingQuantity() {
      return this.article.remainingQuantity;
    },
  },
  watch: {
    setAll: function() {
      this.setAllQuantity();
    },
  },
  methods: {
    setLabelQuantityForPrinting(label, event) {
      if (this.remainingQuantity) {
        if (event > this.remainingQuantity) {
          this.errors[
            label.labelId
          ] = `Maximum quantity reached, remaining quantity: ${
            this.remainingQuantity
          }`;
          return;
        }
      }
      if (this.errors[label.labelId] || this.errors[label.labelId] !== "") {
        this.errors[label.labelId] = "";
      }
      this.$emit("updateLabelQuantity", {
        article: this.article,
        label: label,
        quantity: parseInt(event),
      });
      this.key++;
    },
    setMaxToAllLabels() {
      this.setAll = this.remainingQuantity;
      this.key++;
    },
    setAllQuantity() {
      const quantity = this.setAll === "" ? "0" : this.setAll;
      if (this.remainingQuantity) {
        if (quantity > this.remainingQuantity) {
          this.setAllError = `Maximum quantity reached, remaining quantity: ${
            this.remainingQuantity
          }`;
          return;
        }
      }
      this.computedLabels.forEach(label => {
        this.setLabelQuantityForPrinting(label, quantity);
      });
    },
    async fetchPreview(label) {
      this.loading = true;
      try {
        const response = await this.$store.$api.post(
          "/api/printjobs/article/preview",
          {
            articleId: this.article.id
              ? this.article.id
              : this.article.articleId,
            labelId: label.labelId,
            articleData: this.article.articleData,
            editableData:
              this.article.editableData &&
              this.article.editableData.map(({ key, data }) => ({
                key,
                data,
              })),
            orderData:
              this.orderData &&
              this.orderData.map(({ key, data }) => ({ key, data })),
            orderId: this.orderId,
            connectorId: this.connector
          }
        );
        this.showPreview = true;
        this.currentPreview = `data:image/png;base64,${response.data.image}`;
      } catch (e) {
        const errorMessage =  e.response.data.Message;
        this.errorMessage = errorMessage || "Could not generate preview";
      }
      this.loading = false;
    },
    hidePreview() {
      this.showPreview = false;
      this.currentPreview = "";
    },
  },
};
</script>

<style scoped>
.labelpreview {
  max-width: 90%;
  border-color: gray;
  border-style: solid;
  border-radius: 3px;
  border-width: 1px;
}
.info {
  display: flex;
  flex-direction: row;
}
.info p {
  align-self: center;
  padding-left: 15px;
  font-style: italic;
}
.orange {
  color: orange;
}
</style>
